import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { TranslationPipe } from '@rent2end/core/translation';

import { ConfirmationDialogData } from './confirmation-dialog-data.type';

@Component({
  selector: 'r2e-confirmation-dialog',
  imports: [MatButton,MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle, MatIcon, TranslationPipe],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
  public dialogData = inject<ConfirmationDialogData>(MAT_DIALOG_DATA);
}
